import React, { useState, useEffect } from 'react';
import Step1BasicInfo from './Step1BasicInfo';
import Step2Contact from './Step2Contact';
import Step3Services from './Step3Services';
import Step4AboutSocial from './Step4AboutSocial';
import Step5Review from './Step5Review';
import WizardProgress from './WizardProgress';
import './ProfileWizard.css';

const STORAGE_KEY = 'wizardFormData';

const DEFAULT_FORM_DATA = {
    // Step 1
    business_name: '',
    tagline: '',
    industry: '',

    // Step 2
    email: '',
    phone: '',
    street_address: '',
    city: '',
    state: '',
    zip_code: '',
    country: 'United States',

    // Step 3
    services: [],

    // Step 4
    about_us: '',
    mission_statement: '',
    facebook_url: '',
    twitter_url: '',
    instagram_url: '',
    linkedin_url: '',
    youtube_url: '',

    // Settings
    profile_name: 'My Business Profile',
    is_default: true,
};

const ProfileWizard = () => {
    const [currentStep, setCurrentStep] = useState(1);
    const [formData, setFormData] = useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            return saved ? JSON.parse(saved) : DEFAULT_FORM_DATA;
        } catch {
            return DEFAULT_FORM_DATA;
        }
    });

    const totalSteps = 5;

    // Auto-save to localStorage on every form change
    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(formData));
    }, [formData]);

    const handleNext = () => {
        if (currentStep < totalSteps) {
            setCurrentStep(currentStep + 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handlePrevious = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handleGoToStep = (step) => {
        if (step >= 1 && step <= totalSteps) {
            setCurrentStep(step);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value,
        }));
    };

    const renderStep = () => {
        switch (currentStep) {
            case 1:
                return <Step1BasicInfo data={formData} onChange={handleChange} />;
            case 2:
                return <Step2Contact data={formData} onChange={handleChange} />;
            case 3:
                return <Step3Services data={formData} onChange={handleChange} />;
            case 4:
                return <Step4AboutSocial data={formData} onChange={handleChange} />;
            case 5:
                return <Step5Review data={formData} onGoToStep={handleGoToStep} />;
            default:
                return null;
        }
    };

    return (
        <div className="profile-wizard">
            <div className="wizard-header">
                <h1>Create Your Business Profile</h1>
                <p>Step {currentStep} of {totalSteps}</p>
            </div>

            <WizardProgress currentStep={currentStep} totalSteps={totalSteps} />

            <div className="wizard-content">
                {renderStep()}
            </div>

            <div className="wizard-footer">
                {currentStep > 1 && (
                    <button
                        type="button"
                        className="btn-secondary"
                        onClick={handlePrevious}
                    >
                        ← Previous
                    </button>
                )}
                {currentStep < totalSteps && (
                    <button
                        type="button"
                        className="btn-primary"
                        onClick={handleNext}
                        style={currentStep === 1 ? { marginLeft: 'auto' } : {}}
                    >
                        Continue →
                    </button>
                )}
            </div>
        </div>
    );
};

export default ProfileWizard;
